<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as TASK_STATE_TYPES } from './store'
import { ROUTES as TASK_STATE_ROUTES } from './router'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxListMixin from '../../../components/thux-list/ThuxListMixin'

import TaskStateTable from './TaskStateTable'
import TaskStateCommonFilters from './TaskStateCommonFilters'
import TaskStateEdit from './TaskStateEdit.vue'

export default {
  name: 'TaskStateList',
  mixins: [ThuxListMixin],
  components: {
    'component-table': TaskStateTable,
    'common-filters': TaskStateCommonFilters,
    'component-edit': TaskStateEdit,
    'component-detail': TaskStateEdit
  },
  data () {
    return {
      TASK_STATE_ROUTES,
      title: this.$t('States'),
      rolePerm: ['tasks_taskstate_list'],
      actionEnablePermission: ['tasks_taskstate_enable'],
      actionDisablePermission: ['tasks_taskstate_disable'],
      fieldName: 'code',
      searchFields: [
        { key: 'filter__code__icontains', placeholder: this.$t('Code'), type: 'text', col: 4 },
        { key: 'filter__name__icontains', placeholder: this.$t('Name'), type: 'text', col: 4 },
        { key: 'filter__is_final', placeholder: this.$t('Is final'), type: 'boolean', col: 4 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      ...TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.GETTERS
    }),
    showList () {
      return this.$route.name === this.TASK_STATE_ROUTES.TASK_STATE_LIST
    },
    canSeeActionSelect () {
      return true
    },
    canAddInstance () {
      return hasPerm('tasks_taskstate_create')
    }
  },
  methods: {
    ...mapMutations({
      setSelectedList: TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.MUTATIONS.setSelectedList,
      setSelectAll: TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...TASK_STATE_TYPES.GENERIC.task['task-state'].LIST.ACTIONS
    })
  }
}
</script>
